// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"97":"asset","183":"snapshot","962":"home"}[chunkId] + "." + {"97":"93896c17","183":"65391f35","962":"7bda412c"}[chunkId] + ".js";
};